import designTokens from '@customink/design-tokens/build/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiSwitch: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    height: theme.spacing(3),
                    width: theme.spacing(6),
                    padding: 0,
                    marginRight: theme.spacing(1),
                    background: designTokens.color.gray.disabled.value,
                    borderRadius: theme.spacing(1.5),
                    position: 'relative',
                    transition: 'background .3s cublic-bezer(.22, .61, .36, 1)',
                    '&.MuiSwitch-sizeSmall': {
                        height: theme.spacing(2),
                        width: theme.spacing(4),
                    },
                },
                switchBase: {
                    padding: theme.spacing(0.375),
                    '&.Mui-checked': {
                        color: designTokens.color.shade.white.value,
                        transform: 'translateX(24px)',
                        '& + .MuiSwitch-track': {
                            backgroundColor: designTokens.color.blue.default.value,
                            opacity: 1,
                        },
                    },
                    '&.Mui-disabled&.Mui-checked': {
                        color: designTokens.color.shade.white.value,
                        '& + .MuiSwitch-track': {
                            opacity: 0.3,
                        },
                    },
                },
                sizeSmall: {
                    '.MuiSwitch-thumb': {
                        height: theme.spacing(1.25),
                        width: theme.spacing(1.25),
                    },
                    '.MuiSwitch-switchBase': {
                        padding: theme.spacing(0.375),
                    },
                },
                thumb: {
                    height: theme.spacing(2.25),
                    width: theme.spacing(2.25),
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=toggleTheme.js.map